var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Confirm, Notify, Alert } from '@sumup/icons';
import styled from '../../styles/styled';
import { typography } from '../../styles/style-mixins';
import { CLASS_DISABLED } from './constants';
const wrapperStyles = ({ theme }) => css `
  display: block;
  margin-top: ${theme.spacings.bit};
  color: var(--cui-fg-subtle);
  transition: color ${theme.transitions.default};

  .${CLASS_DISABLED} & {
    color: var(--cui-fg-subtle-disabled);
  }
`;
const validStyles = ({ showValid }) => showValid &&
    css `
    color: var(--cui-fg-success);

    .${CLASS_DISABLED} & {
      color: var(--cui-fg-success-disabled);
    }
  `;
const warningStyles = ({ hasWarning }) => hasWarning &&
    css `
    color: var(--cui-fg-warning);

    .${CLASS_DISABLED} & {
      color: var(--cui-fg-warning-disabled);
    }
  `;
const invalidStyles = ({ invalid }) => invalid &&
    css `
    color: var(--cui-fg-danger);

    .${CLASS_DISABLED} & {
      color: var(--cui-fg-danger-disabled);
    }
  `;
const Wrapper = styled('span')(typography('two'), wrapperStyles, validStyles, invalidStyles, warningStyles);
const iconWrapperStyles = ({ theme }) => css `
    display: inline-block;
    position: relative;
    width: ${theme.iconSizes.kilo};
    height: ${theme.iconSizes.kilo};
    vertical-align: text-top;
    margin-right: ${theme.spacings.bit};
  `;
const IconWrapper = styled('div')(iconWrapperStyles, validStyles, invalidStyles, warningStyles);
const getIcon = (props) => {
    switch (true) {
        case props.disabled: {
            return null;
        }
        case props.invalid: {
            return (_jsx(IconWrapper, { children: _jsx(Alert, { role: "presentation", size: "16" }) }));
        }
        case props.hasWarning: {
            return (_jsx(IconWrapper, { children: _jsx(Notify, { role: "presentation", size: "16" }) }));
        }
        case props.showValid: {
            return (_jsx(IconWrapper, { children: _jsx(Confirm, { role: "presentation", size: "16" }) }));
        }
        default: {
            return null;
        }
    }
};
/**
 * @private
 */
export const FieldValidationHint = (_a) => {
    var { validationHint } = _a, props = __rest(_a, ["validationHint"]);
    const icon = getIcon(props);
    const hasMessage = Boolean(validationHint);
    const isStatusMessage = Boolean(props.invalid || props.hasWarning || props.showValid);
    return (_jsxs(_Fragment, { children: [hasMessage && !isStatusMessage && (_jsxs(Wrapper, Object.assign({}, props, { children: [icon, validationHint] }))), _jsx("span", Object.assign({ role: "status", "aria-live": "polite" }, { children: hasMessage && isStatusMessage && (_jsxs(Wrapper, Object.assign({}, props, { children: [icon, validationHint] }))) }))] }));
};
